import React from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Link } from 'react-router'
import UnableToLoad from '../messages/UnableToLoad'
import Switch from '../ui/Switch'
import './trendingTagsBox.pcss'


const TrendingTagsBox = React.memo(({
  trending,
  failedToLoad,
}) => (
  <div className='sidebox'>
    <div className='sidebox-header'>
      <Link to='/aihetunnisteet' title='Näytä listaus aihetunnisteista'>
        <span>Pinnalla</span>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width='19' height='19' aria-hidden='true' className='widget-box__header__icon'>
          <circle cx='100' cy='100' r='80' fill='none' strokeWidth='14' />
          <line x1='85' y1='70' x2='120' y2='100' strokeWidth='12' />
          <line x1='85' y1='130' x2='120' y2='100' strokeWidth='12' />
        </svg>
      </Link>
    </div>

    <div className='sidebox-content'>
      { failedToLoad && trending.size === 0 &&
        <UnableToLoad errorText='Aiheita ei saatu ladattua.' />
      }

      <div className='trending-tags-list'>
        { trending.map((tag, i) => (
          <Switch key={ tag.get('id') } tag={ tag } />
        )) }
        <Link to='/aihetunnisteet' className='trending-tags-all-tags-link'>Katso kaikki <i className='fa fa-angle-double-right' aria-hidden='true' /></Link>
      </div>
    </div>
  </div>
))

TrendingTagsBox.displayName = 'TrendingTagsBox'

TrendingTagsBox.propTypes = exact({
  trending: ImmutablePropTypes.list.isRequired,
  failedToLoad: PropTypes.bool.isRequired,
})

export default TrendingTagsBox
